import { render, staticRenderFns } from "./LongReadDesktop.vue?vue&type=template&id=15ca7f1a&"
import script from "./LongReadDesktop.vue?vue&type=script&lang=js&"
export * from "./LongReadDesktop.vue?vue&type=script&lang=js&"
import style0 from "./LongReadDesktop.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports